import React from "react";
import { Button, Modal, Table, Alert, Spin } from "antd";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import { custInfRecordProps } from "../index";
import { useEventLog } from "../queries";
import { ColumnsType } from "antd/es/table";
import { useSearchColumn } from "Components/DeviceBackup/Components/utils";

interface eventLogProps {
  record: custInfRecordProps;
  eventLogModalvisible: boolean;
  setEventLogModalvisible: (arg: boolean) => void;
  setRecord: (arg: custInfRecordProps) => void;
}

const EventLogC = React.memo(({ record, eventLogModalvisible, setEventLogModalvisible, setRecord }: eventLogProps) => {
  const { t } = useTranslation();
  const { data: customerEventLog = [], isFetching: customerEventLogFetching } = useEventLog(
    record.cid,
    eventLogModalvisible
  );
  const getColumnSearchProps = useSearchColumn();

  const columns: ColumnsType<typeof customerEventLog[0]> = [
    {
      title: t("ISMS.Message"),
      dataIndex: "message",
      ellipsis: true,
      width: "80%",
      ...getColumnSearchProps("message"),
    },
    {
      title: t("ISMS.Time"),
      width: "20%",
      sorter: (a, b) => {
        return a.timestamp - b.timestamp;
      },
      render: (_, record) => {
        const date = new Date(record.timestamp * 1000);
        const timestamp = `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;

        return timestamp;
      },
      defaultSortOrder: "descend",
    },
  ];

  return (
    <Modal
      title={t("ISMS.EventLog")}
      className={styles.modal}
      visible={eventLogModalvisible}
      onCancel={() => {
        setEventLogModalvisible(false);
        setRecord({ cid: undefined });
      }}
      footer={[
        <Button
          key="submit"
          type="primary"
          loading={customerEventLogFetching}
          onClick={() => {
            setEventLogModalvisible(false);
          }}
        >
          {t("ISMS.Confirm")}
        </Button>,
      ]}
    >
      {customerEventLogFetching ? (
        <Spin tip="Loading...">
          <Alert
            message="Getting Data"
            description="We are now getting data from server, please wait for a few seconds"
          />
        </Spin>
      ) : (
        <Table
          className={styles.table}
          columns={columns}
          dataSource={customerEventLog}
          rowKey={(record) => `${record.message} ${record.timestamp}`}
        />
      )}
    </Modal>
  );
});

export default EventLogC;
